import React from 'react';
import { connect } from 'react-redux';
import TablaComprobantes from '../TablaComprobantes/TablaComprobantes';
import * as actions from "../../../../store/actions";

const TablaPedidosPendientes = (props) => {
  const {
    comprobantes,
    loading,
    estaCargado,
    comprobantesPorCliente,
    loadingPorCliente,
    estaCargadoPorCliente,
    inClientInfo,
  } = props;

  const data = () => {
    let listaComprobantes = inClientInfo
      ? estaCargadoPorCliente ? comprobantesPorCliente : []
      : estaCargado ? comprobantes : [];

    return listaComprobantes && listaComprobantes.map((comprobante) => {
      return {
        fecha: comprobante.fecha,
        comprobante: comprobante.comprobante,
        referencia: comprobante.referencia,
        numeroExterno: comprobante.numeroExterno,
        monto: comprobante.monto && comprobante.monto.toFixed(2),
        idComproba: comprobante.idComproba,
        idSistema: comprobante.idSistema,
        idSucursal: comprobante.idSucursal,
        clienteNombre: comprobante.clienteNombre,
        clienteCodigo: comprobante.clienteCodigo,
        montoPendiente: comprobante.montoPendiente && comprobante.montoPendiente.toFixed(2),
      };
    });
  };

  return (
    <TablaComprobantes 
      data={data()} 
      loading={inClientInfo ? loadingPorCliente : loading} 
      minHeight='300px'
      maxHeight='380px'
      onFiltersClick={() => props.onShowFiltersModal()}
      inClientInfo={inClientInfo}
      tituloTabla={"Pedidos pendientes" }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    comprobantes: state.ventas.comprobantesPedidosPendientes.comprobantes,
    loading: state.ventas.comprobantesPedidosPendientes.loading,
    estaCargado: state.ventas.comprobantesPedidosPendientes.estaCargado,
    comprobantesPorCliente: state.ventas.comprobantesPedidosPendientes.comprobantesPorCliente,
    loadingPorCliente: state.ventas.comprobantesPedidosPendientes.loadingPorCliente,
    estaCargadoPorCliente: state.ventas.comprobantesPedidosPendientes.estaCargadoPorCliente,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Pedidos pendientes', ['pedido']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaPedidosPendientes);